import React, { useCallback, useEffect } from "react";
import { Card, Button, WhatsappIcon, Instagramicon } from "Components";
import { useGetAllCards } from "./useAllCardsApis";
import { useSearchContext } from "Context/SearchContext";
import "./style.css";
import { AllCardsSkeleton } from "./allCardsSkeleton";
import { Facebookicon } from "Components/Facebookicon";

export const AllCards = () => {
  const { searchTerm } = useSearchContext();
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    refetch,
  } = useGetAllCards({
    limit: 20,
    page: 1,
    keywords: searchTerm || "",
  });

  const loadMore = useCallback(() => {
    if (!isFetchingNextPage && hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  useEffect(() => {
    refetch();
  }, [searchTerm, refetch]);

  if (isLoading) {
    return <AllCardsSkeleton />;
  }

  return (
    <div style={{ width: "90%" }}>
      <div className="icon_container_home">
        <a href="http://wa.me/+96171728733" target="_blank">
          <WhatsappIcon className="home_Facebook_hover green" />
        </a>
        <a href="https://www.facebook.com/marketique.online" target="_blank">
          <Facebookicon className="home_Facebook_hover facebookColor" />
        </a>
        <a href="https://www.instagram.com/marketique.online/" target="_blank">
          <Instagramicon className="home_Facebook_hover instagram" />
        </a>
      </div>
      <h1 className="main_header">All Products</h1>
      <div className="flex_r card_list">
        <>
          {data.pages.map((page, pageIndex) => (
            <React.Fragment key={pageIndex}>
              {page.items.map((product) => (
                <Card data={product} key={product._id} />
              ))}
            </React.Fragment>
          ))}
        </>
      </div>
      <div className="flex_c align_items_center">
        {hasNextPage && (
          <Button
            name={isFetchingNextPage ? "Loading..." : "Load More"}
            onClick={loadMore}
            disabled={isFetchingNextPage}
          />
        )}
      </div>
    </div>
  );
};
